export default __webpack_public_path__ + "static/M-1_04-02462f0e0f0b7835375554d9795ad12b.png";